<template>
  <span v-if="contact">
    <button class="button hollow secondary" @click="showLogCallModal()">
      Log Call
    </button>

    <log-call-modal :contact="contact" ref="logCallModal" />
    <log-call-modal :contact="contact" :call-id="editCallId" ref="editLogCallModal" />
  </span>
</template>

<script>
import LogCallModal from './LogCallModal'
import { EventBus } from '../../events'

export default {
  components: {
    LogCallModal
  },
  props: {
    contact: Object
  },
  data () {
    return {
      editCallId: null
    }
  },
  methods: {
    showLogCallModal () {
      this.$refs.logCallModal.openModal()
    },
    async openEditCallModal (callId) {
      this.editCallId = callId
      // open modal after the ref has time to create
      await this.$nextTick()
      this.$refs.editLogCallModal.openModal()
    }
  },
  created () {
    EventBus.$on('logCallModalEditCall', this.openEditCallModal)
  },
  beforeDestroy () {
    EventBus.$off('logCallModalEditCall', this.openEditCallModal)
  }
}
</script>
